<script setup lang="ts">
import MainLogo from '../components/MainLogo.vue'
// import '@splidejs/vue-splide/css'
</script>

<template>
  <div class="flex flex-col items-center justify-center h-fit screen">
    <div class="flex-grow" />
    <div class="text-center px-1 mt-4 mb-10 text-zinc-200" ref="logo">
      <MainLogo class="max-w-full w-[30rem] sm:w-[40rem] lg:w-[50rem]" />
      <h1 class="text-4xl font-bold shadow-black/50 text-shadow-sm hidden">Time Wasted on Marathon</h1>
      <h2 class="text-lg md:text-xl font-thin shadow-black/50 text-shadow-sm hidden">In the heavens, they are waiting
      </h2>

      <h2 class="text-xl md:text-2xl font-thin shadow-black/50 text-shadow-sm">Coming soon! Maybe...</h2>
    </div>
    <div class="flex-grow" />
    <footer class="mt-2 mb-10 text-zinc-200 flex flex-col lg:flex-row justify-center items-center gap-x-2 gap-y-1 text-center">
      <span class="flex flex-col sm:flex-row justify-center items-center gap-x-2 gap-y-1 text-center">
        <a class="!decoration-1 !decoration-dotted" href="https://karmageddongames.com">&copy; Karmageddon Games {{ (new
          Date()).getFullYear() }}</a>
      </span>
    </footer>
    <!-- <TheFooter name="Time Wasted on Marathon" patreon>
      <a class="!decoration-1 !decoration-dotted" href="https://karmageddongames.com">&copy; Karmageddon Games {{ (new
        Date()).getFullYear() }}</a>
      <template #privacy>
        <RouterLink class="!decoration-1 !decoration-dotted" to="/privacy">Privacy</RouterLink>
      </template>
      <template #ad>
        <ins class="adsbygoogle w-[320px] h-[100px] sm:w-[468px] sm:h-[60px] lg:w-[728px] lg:h-[90px] block z-10 mx-auto"
          data-ad-client="ca-pub-6332373031553935"
          data-ad-slot="8162200044"
          data-ad-format="auto"
          data-full-width-responsive="true"></ins>
        <div id="footer" class="w-[320px] h-[110px] sm:w-[468px] sm:h-[110px] lg:w-[728px] lg:h-[110px] flex justify-center"></div>
      </template>
    </TheFooter> -->
  </div>
</template>

<style lang="postcss">
html {
  scroll-behavior: smooth;
}

.screen {
  min-height: calc(100dvh - 3rem);
}

.expanded-search {
  max-width: 18rem;
}

.collapsed-search {
  max-width: 6.5rem;
}

@media (min-width: 768px) {
  .expanded-search {
    max-width: 24rem;
  }
}

.bullet-1 {
  opacity: 0;
  animation: dot 1.3s infinite;
  animation-delay: 0.1s;
}

.bullet-2 {
  opacity: 0;
  animation: dot 1.3s infinite;
  animation-delay: 0.2s;
}

.bullet-3 {
  opacity: 0;
  animation: dot 1.3s infinite;
  animation-delay: 0.3s;
}

@keyframes dot {
  0% {
    opacity: 0;
  }

  20% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.reduced-motion .bullet-1,
.reduced-motion .bullet-2,
.reduced-motion .bullet-3 {
  animation-play-state: paused;
  opacity: 1;
}

@media (prefers-reduced-motion) {

  .bullet-1,
  .bullet-2,
  .bullet-3 {
    animation-play-state: paused;
    opacity: 1;
  }
}

/* Splide fade gradient effect */
.splide-with-fade {
  position: relative;
}

.splide-with-fade .splide__track {
  -webkit-mask-image: linear-gradient(to right,
      transparent 0%,
      black 16px,
      black calc(100% - 16px),
      transparent 100%);
  mask-image: linear-gradient(to right,
      transparent 0%,
      black 16px,
      black calc(100% - 16px),
      transparent 100%);
}

/* Fallback for older browsers that don't support mask-image */
@supports not (mask-image: linear-gradient(to right, black, black)) {
  .splide-with-fade {
    position: relative;
  }

  .splide-with-fade::before,
  .splide-with-fade::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 16px;
    z-index: 10;
    pointer-events: none;
  }

  .splide-with-fade::before {
    left: 0;
    background: linear-gradient(to right, var(--bg-color, #1f2937), transparent);
  }

  .splide-with-fade::after {
    right: 0;
    background: linear-gradient(to left, var(--bg-color, #1f2937), transparent);
  }
}
</style>
